import { render } from "./TopMonthActivitiesSlide.vue?vue&type=template&id=27a36340&scoped=true"
import script from "./TopMonthActivitiesSlide.vue?vue&type=script&lang=js"
export * from "./TopMonthActivitiesSlide.vue?vue&type=script&lang=js"

import "./TopMonthActivitiesSlide.vue?vue&type=style&index=0&id=27a36340&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27a36340"]])

export default __exports__